import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/options-saas/app/(marketing)/mcp/client.tsx");
